export default "__VITE_ASSET__d981a89e__"